import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.StatementSummary.Delete.IRequest;
type Response = Api.Core.StatementSummary.Delete.IResponse;
type Headers = Api.Core.StatementSummary.Delete.IHeaders;
const url = '/api/DealerManagement/StatementSummary/:id';
export default async function statementSummaryDeleteApi(id: number): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.delete,
    url: createPathFromRoute(url, { id }),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
